import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ui/ErrorBoundary';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import AthleteProfile from './pages/AthleteProfile';
import Feed from './pages/Feed';
import Search from './pages/Search';
import Messages from './pages/Messages';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';
import Learn from './pages/Learn';
import Athletes from './pages/Athletes';
import Teams from './pages/Teams';
import Achievements from './pages/Achievements';
import Marketplace from './pages/Marketplace';
import About from './pages/About';
import Careers from './pages/Careers';
import Press from './pages/Press';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import Accessibility from './pages/Accessibility';
import AdminDashboard from './pages/admin/AdminDashboard';
import VerifyAuth from './pages/VerifyAuth';
import Photos from './pages/Photos';
import TestFeatures from './pages/TestFeatures';

function App() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <div className={`min-h-screen flex flex-col ${darkMode ? 'dark' : ''}`}>
            <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
            <main className="flex-grow bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
              <Routes>
              {/* Home route */}
              <Route path="/" element={<Home />} />
              
              {/* Authentication routes - multiple paths for the same components */}
              <Route path="/login" element={<Login />} />
              <Route path="/signin" element={<Login />} />
              <Route path="/iniciar-sesion" element={<Login />} />
              
              <Route path="/register" element={<Register />} />
              <Route path="/signup" element={<Register />} />
              <Route path="/registro" element={<Register />} />
              
              {/* Verification tool */}
              <Route path="/verify-auth" element={<VerifyAuth />} />
              
              {/* Testing tool */}
              <Route 
                path="/test-features" 
                element={
                  <ProtectedRoute>
                    <TestFeatures />
                  </ProtectedRoute>
                } 
              />
              
              {/* Main platform routes */}
              <Route path="/learn" element={<Learn />} />
              <Route path="/athletes" element={<Athletes />} />
              <Route path="/teams" element={<Teams />} />
              <Route 
                path="/achievements" 
                element={
                  <ProtectedRoute>
                    <Achievements />
                  </ProtectedRoute>
                } 
              />
              <Route path="/marketplace" element={<Marketplace />} />
              
              {/* Photos route */}
              <Route 
                path="/photos" 
                element={
                  <ProtectedRoute>
                    <Photos />
                  </ProtectedRoute>
                } 
              />
              
              {/* Profile routes */}
              <Route 
                path="/profile/:id" 
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/mi-perfil" 
                element={
                  <ProtectedRoute>
                    <AthleteProfile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/my-profile" 
                element={
                  <ProtectedRoute>
                    <AthleteProfile />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/feed" 
                element={
                  <ProtectedRoute>
                    <Feed />
                  </ProtectedRoute>
                } 
              />
              <Route path="/search" element={<Search />} />
              <Route 
                path="/messages" 
                element={
                  <ProtectedRoute>
                    <Messages />
                  </ProtectedRoute>
                } 
              />
              
              {/* Admin Routes */}
              <Route 
                path="/admin" 
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                } 
              />
              
              {/* Company Pages */}
              <Route path="/about" element={<About />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/press" element={<Press />} />
              <Route path="/contact" element={<Contact />} />
              
              {/* Legal Pages */}
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/accessibility" element={<Accessibility />} />
              

              
              {/* Catch all route for 404 - this must be last */}
              <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;